import { createStore } from 'vuex'

export default createStore({
  state: {
    data_last_received_at : localStorage.getItem('data_last_received_at')
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
